import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import userDetail from "Stores/userDetail";
import PricingStore from "Stores/Pricing";
import Utils from "Utils/utils";
import { ReactComponent as MostPopular } from "Assets/Pricing/mostPopular.svg";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import CustomTooltip from "Components/common/CustomTooltip";
import ToggleSwitch from "Components/common/ToggleSwitch";
import ToggleContext from "./context/ToggleContext";
import { ReactComponent as Cross } from "Assets/Pricing/pricingClose.svg";
import { ReactComponent as Check } from "Assets/Pricing/pricingCheck.svg";
import { ReactComponent as OutreachPlanIcon } from "Assets/Pricing/outreachTab.svg";
import { ReactComponent as DataPlanIcon } from "Assets/Pricing/dataTab.svg";
import { observer } from "mobx-react-lite";
import { MP_EVENT } from "static/constant";

export const pricingPlanObj = {
  free: {
    // subText: "Get started with multi-channel outreach",
    color: "#3953fb",
    planAmountSubText: "/ Forever"
  },
  basic: {
    // subText: "Designed for small teams scaling outbound",
    color: "#FA6B63",
    planAmountSubText: "/ User/Month"
  },
  pro: {
    // subText: "Maximize outreach with automation",
    color: "#01B018",
    isPopular: true,
    planAmountSubText: "/ User/Month"
  },
  custom: {
    // subText: "Enterprise-grade outbound at scale",
    color: "#AD007F"
  },
  proplus: {
    // subText: "Enterprise-grade outbound at scale",
    color: "#AD007F",
    planAmountSubText: "/ User/Month"
  }
};

const PricingPlans = observer((props = {}) => {
  const {
    subscriptionId = "",
    setSelectedTab = () => {},
    selectedTab = "Data"
  } = props || {};

  const { team, userLoggedIn } = userDetail.userInfo || {};
  const { planName, inFreePlan } = userDetail?.userFeatureFlag || {};
  let { isChecked, setIsChecked } = useContext(ToggleContext);
  const history = useHistory();

  const [tooltipVisible, setTooltipVisible] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);

  const [dataOutreachPlans, setDataOutreachPlans] = useState(
    PricingStore.dataOutreachPlans
  );

  const getTogglePlanType = value => {
    PricingStore.setPaymentFormInfo({ annual: value });
    setIsChecked(value);
  };

  const upgradeBtn = (plan = {}) => {
    let planDisplayName = plan?.displayName?.toLowerCase();
    if (userLoggedIn) {
      if (!team) {
        confirmationPopupState.setPopupValues({
          title: "Pricing Purchase Request?",
          content: `Please contact your account administrator to upgrade your account`,
          actionBtnText: "Ok",
          needCancelBtn: false,
          callback: () => {
            confirmationPopupState.setShowPopup(false);
          }
        });
        confirmationPopupState.setShowPopup(true);
      } else {
        if (
          ["basic", "pro"].includes(planName?.toLowerCase()) &&
          ["unlimited", "pro", "basic"].includes(planDisplayName)
        ) {
          confirmationPopupState.setPopupValues({
            content: `Please reach out to <a href="mailto:support@salesgear.io" target="_blank" rel="noopener noreferrer" >support@salesgear.io</a> to upgrade to ${plan?.displayName} plan`,
            actionBtnText: "Ok",
            needCancelBtn: false,
            callback: () => {
              confirmationPopupState.setShowPopup(false);
            }
          });
          confirmationPopupState.setShowPopup(true);
        } else if (planDisplayName !== "custom") {
          PricingStore.setPaymentFormInfo(plan);
          localStorage.setItem("proceedToPay", true);
          history.push("pricing/payment");
        }
      }
    } else {
      if (planDisplayName !== "custom") {
        history.push("/signup");
      }
    }
  };

  const getActionButton = planObj => {
    let buttonValue = "";
    const { displayName } = planObj;

    let idValue =
      displayName?.toLowerCase() == "custom" ? "my_custom_link" : "";

    if (displayName?.toLowerCase() === "custom") {
      buttonValue = "Contact Sales";
    } else if (displayName?.toLowerCase() === "free") {
      buttonValue = "";
    } else {
      buttonValue = "Upgrade";
    }

    return (
      <div
        id={idValue}
        className={`${buttonValue ? "" : "noBorder"} upgradeBtn`}
        onClick={() => upgradeBtn(planObj)}
      >
        {buttonValue}
      </div>
    );
  };

  const showCurrentPlanDom = plan => {
    const { displayName = "" } = plan;

    if (subscriptionId !== null) {
      if (displayName?.toLowerCase() === planName?.toLowerCase()) {
        return true;
      }
    } else {
      return inFreePlan && displayName?.toLowerCase() === "free";
    }

    return false;
  };

  const getTooltipContentForOutreach = (planName, item, val) => {
    const tooltipData = {
      free: {
        emailCredits: `Find up to ${val} prospect email addresses per month, with a daily limit of 10.`,
        phoneNumbers: `Find up to ${val} prospect phone numbers for free, available for lifetime.`,
        callingMinutes: `Lifetime access to ${val} free calling minutes for US & Canada.`,
        emailSends: `Send up to ${val} emails per month from your connected inbox.`,
        deepResearch: `Get AI-curated insights from 100+ sources—key data points and outreach angles without the manual digging.
Saver Mode: 20 credits (~100 sec) | Instant Mode: 40 credits (~30–60 sec)`,
        linkedInOutreach: `Automate up to ${val} LinkedIn actions per month — includes connection requests, messages, InMails, and profile views.`,
        whatsAppOutreach: `Send up to 5 WhatsApp messages per day on the Free plan.`,
        waMonthlyMessages: `Send up to ${val} WhatsApp messages per month.`,
        filters: `Industry, Location, Size, Title and other standard fields.`
      },
      basic: {
        emailCredits: `Find up to ${val} prospect email addresses per month, with a daily limit of 50.`,
        phoneNumbers: `Find up to ${val} prospect phone numbers per month.`,
        callingMinutes: `Get ${val} free calling minutes per month for US & Canada.`,
        emailSends: `Send up to ${val} emails per month with no daily limit per inbox.`,
        deepResearch: `Get AI-curated insights from 100+ sources—key data points and outreach angles without the manual digging.
        Saver Mode: 20 credits (~100 sec) | Instant Mode: 40 credits (~30–60 sec)`,
        linkedInOutreach: `Automate up to ${val} LinkedIn actions per month — includes connection requests, messages, InMails, and profile views.`,
        whatsAppOutreach: `Connect 1 WhatsApp account and send up to 10 automated messages per day.`,
        waMonthlyMessages: `Send up to ${val} WhatsApp messages per month.`,
        filters: `Industry, Location, Size, Title and other standard fields.`
      },
      pro: {
        emailCredits: `Find up to ${val} prospect email addresses per month, with no daily limit.`,
        phoneNumbers: `Find up to ${val} prospect phone numbers per month.`,
        callingMinutes: `Get ${val} free calling minutes per month for US & Canada.`,
        emailSends: `Send up to ${val} emails per month, ideal for high-volume outreach.`,
        deepResearch: `Get AI-curated insights from 100+ sources—key data points and outreach angles without the manual digging.
        Saver Mode: 20 credits (~100 sec) | Instant Mode: 40 credits (~30–60 sec)`,
        linkedInOutreach: `Automate up to ${val} LinkedIn actions per month — includes connection requests, messages, InMails, and profile views.`,
        whatsAppOutreach: `Connect 1 WhatsApp account and send up to 100 automated messages per day.`,
        waMonthlyMessages: `Send up to ${val} WhatsApp messages per month.`,
        filters: `Technology, Funding, Department Growth and more.`
      },
      custom: {
        emailCredits: "Flexible email credits to match your prospecting needs.",
        phoneNumbers: `Find up to ${val} prospect phone numbers per month, or customize as needed.`,
        callingMinutes: "Flexible calling minutes tailored to your business needs.",
        emailSends: "Flexible email sending limits tailored to your needs.",
        deepResearch: `Get AI-curated insights from 100+ sources—key data points and outreach angles without the manual digging.
Saver Mode: 20 credits (~100 sec) | Instant Mode: 40 credits (~30–60 sec)`,
        linkedInOutreach: `Automate LinkedIn actions at a volume tailored to your needs — including connection requests, messages, InMails, and profile views.`,
        whatsAppOutreach: `Connect WhatsApp accounts and send messages at a volume tailored to your needs.`,
        waMonthlyMessages: `Flexible WhatsApp messaging limits tailored to your needs.`,
        filters: `Technology, Funding, Department Growth and more.`
      }
    };

    const planKey = planName.toLowerCase().replace(/\s+/g, "");
    const resolvedKey = tooltipData[planKey] ? planKey : planKey.startsWith("pro") ? "pro" : planKey;
    return tooltipData[resolvedKey]?.[item] || tooltipData["custom"]?.[item] || "No information available.";
  };

  const getTooltipContent = (planName, creditConsumption) => {
    const tooltipData = {
      free: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      basic: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      pro: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      custom: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      proplus: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ]
    };

    return tooltipData[planName] || "No information available.";
  };

  const handleTooltipVisibility = (planName, isVisible) => {
    if (isVisible) {
      setTooltipVisible(planName);
      setHoveredItem(planName);
    } else {
      setTooltipVisible(null);
      setHoveredItem(null);
    }
  };

  const getCreditsData = (plan, idx) => {
    const {
      usFreeCallingMinutesEligible = 0,
      displayName = "",
      liMaxInvitePerMonth = 0,
      noOfWaAccountsEligible = 0,
      waMaxMessagesPerDay = 0,
      waMaxMessagesPerMonth = 0,
      deepResearchEnabled = false,
      deepResearchCreditsEligible = 0,
      creditConsumption = {},
      creditsEligible = 0,
      emailFinderEnabled = false,
      phoneEnabled = false,
      emailSendLimit = 0
    } = plan;

    const isAdvancedFilters = ["pro", "custom", "unlimited", "proplus"].includes(
      displayName.toLowerCase().replace(/\s+/g, "")
    );

    const isCustom = displayName.toLowerCase() === "custom";
    return (
      <>
        {selectedTab.toLowerCase() === "data" && (
          <div className="totalCreditsWrapper">
            <hr className="divider" />
            <div
              className="totalCredits"
              style={{
                cursor: "pointer",
                textDecoration: "underline dotted",
                textUnderlineOffset: "5px"
              }}
              onMouseEnter={() => handleTooltipVisibility(displayName, true)}
              onMouseLeave={() => handleTooltipVisibility(displayName, false)}
            >
              {`${Utils.numberWithCommas(creditsEligible)} ${
                creditsEligible > 0 ? "Credits" : "Credit"
              }`}
              {tooltipVisible === displayName &&
                hoveredItem === displayName && (
                  <CustomTooltip
                    dataOutreachCreditsContent={getTooltipContent(
                      Utils.removeSpaces(displayName).toLowerCase(),
                      creditConsumption
                    )}
                    isDataOutreachData={true}
                    className="totalDataCredits"
                  />
                )}
            </div>
            <hr className="divider" />
          </div>
        )}
        {selectedTab.toLowerCase() !== "data" && (
          <div className="outreachPlanDivider">
            <hr className="divider" />
          </div>
        )}
        <div className="creditsCardWrapper">
          <div
            className="featureWrapper"
            onMouseEnter={() => handleTooltipVisibility(displayName, true)}
            onMouseLeave={() => handleTooltipVisibility(displayName, false)}
            style={{ position: "relative" }}
          >
            {selectedTab.toLowerCase() !== "data" && (
              <>
                <div className="featureCheckIcon">
                  {isCustom || creditsEligible > 0 ? <Check /> : <Cross />}
                </div>{" "}
                <div
                  className="outreactTotalCredits"
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline dotted",
                    textUnderlineOffset: "5px"
                  }}
                >
                  {`${
                    isCustom
                      ? "Custom"
                      : Utils.numberWithCommas(creditsEligible)
                  } ${
                    isCustom ? "" : creditsEligible > 0 ? "Credits" : "Credit"
                  }`}
                </div>
                {tooltipVisible === displayName &&
                  hoveredItem === displayName && (
                    <CustomTooltip
                      dataOutreachCreditsContent={getTooltipContent(
                        Utils.removeSpaces(displayName).toLowerCase(),
                        creditConsumption
                      )}
                      isDataOutreachData={true}
                      className="tooltipTotalCreditsOutreach"
                    />
                  )}
              </>
            )}
          </div>
          {selectedTab.toLowerCase() !== "data" && (
            <div
              className="featureWrapper"
              onMouseEnter={() => {
                setTooltipVisible(`Plan ${idx + 1}`);
                setHoveredItem("emailSends");
              }}
              onMouseLeave={() => {
                setTooltipVisible(null);
                setHoveredItem(null);
              }}
              style={{ position: "relative" }}
            >
              <div className="featureCheckIcon">
                {emailSendLimit > 0 ? <Check /> : <Cross />}
              </div>
              <div
                className="emailSends"
                style={{
                  cursor: "pointer",
                  textDecoration: "underline dotted",
                  textUnderlineOffset: "5px"
                }}
              >
                {isCustom
                  ? "Custom email sends"
                  : `${Utils.numberWithCommas(emailSendLimit)} email sends`}
              </div>
              {tooltipVisible === `Plan ${idx + 1}` &&
                hoveredItem === "emailSends" && (
                  <CustomTooltip
                    text={getTooltipContentForOutreach(
                      displayName,
                      "emailSends",
                      emailSendLimit
                    )}
                    className="tooltipEmailSends"
                  />
                )}
            </div>
          )}
          <div
            className="featureWrapper"
            onMouseEnter={() => {
              if (selectedTab.toLowerCase() === "outreach") {
                setTooltipVisible(`Plan ${idx + 1}`);
                setHoveredItem("callingMinutes");
              }
            }}
            onMouseLeave={() => {
              if (selectedTab.toLowerCase() === "outreach") {
                setTooltipVisible(null);
                setHoveredItem(null);
              }
            }}
            style={{ position: "relative" }}
          >
            {selectedTab.toLowerCase() === "data" ? (
              <>
                <div className="featureCheckIcon">
                  {emailFinderEnabled ? <Check /> : <Cross />}
                </div>
                <div className="emailFinder">Email Finder</div>
              </>
            ) : (
              <>
                <div className="featureCheckIcon">
                  {usFreeCallingMinutesEligible > 0 ? <Check /> : <Cross />}
                </div>
                <div
                  className="usCallingMinutes"
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline dotted",
                    textUnderlineOffset: "5px"
                  }}
                >
                  {usFreeCallingMinutesEligible > 0 &&
                    `${
                      isCustom
                        ? "Custom"
                        : Utils.numberWithCommas(usFreeCallingMinutesEligible)
                    } calling minutes`}
                </div>
                {tooltipVisible === `Plan ${idx + 1}` &&
                  hoveredItem === "callingMinutes" && (
                    <CustomTooltip
                      text={getTooltipContentForOutreach(
                        displayName,
                        "callingMinutes",
                        usFreeCallingMinutesEligible
                      )}
                      className="tooltipCallingMinutes"
                    />
                  )}
              </>
            )}
          </div>
          <div
            className="featureWrapper"
            onMouseEnter={() => {
              if (selectedTab.toLowerCase() === "outreach") {
                setTooltipVisible(`Plan ${idx + 1}`);
                setHoveredItem("linkedInOutreach");
              }
            }}
            onMouseLeave={() => {
              if (selectedTab.toLowerCase() === "outreach") {
                setTooltipVisible(null);
                setHoveredItem(null);
              }
            }}
            style={{ position: "relative" }}
          >
            {selectedTab.toLowerCase() === "data" ? (
              <>
                <div className="featureCheckIcon">
                  {phoneEnabled ? <Check /> : <Cross />}
                </div>
                <div className="phoneFinder">Phone number Finder</div>
              </>
            ) : (
              <>
                <div className="featureCheckIcon">
                  {liMaxInvitePerMonth > 0 ? <Check /> : <Cross />}
                </div>
                <div
                  className="maxInvite"
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline dotted",
                    textUnderlineOffset: "5px"
                  }}
                >{`${
                  isCustom
                    ? "Custom"
                    : Utils.numberWithCommas(liMaxInvitePerMonth)
                } LinkedIn actions`}</div>
                {tooltipVisible === `Plan ${idx + 1}` &&
                  hoveredItem === "linkedInOutreach" && (
                    <CustomTooltip
                      text={getTooltipContentForOutreach(
                        displayName,
                        "linkedInOutreach",
                        liMaxInvitePerMonth
                      )}
                      className="tooltipLinkedInOutreach"
                    />
                  )}
              </>
            )}
          </div>
          {selectedTab.toLowerCase() !== "data" && (
            <div
              className="featureWrapper"
              onMouseEnter={() => {
                setTooltipVisible(`Plan ${idx + 1}`);
                setHoveredItem("waMonthlyMessages");
              }}
              onMouseLeave={() => {
                setTooltipVisible(null);
                setHoveredItem(null);
              }}
              style={{ position: "relative" }}
            >
              <div className="featureCheckIcon">
                {isCustom || waMaxMessagesPerMonth > 0 ? <Check /> : <Cross />}
              </div>
              <div
                className="waMonthlyMessages"
                style={{
                  cursor: "pointer",
                  textDecoration: "underline dotted",
                  textUnderlineOffset: "5px"
                }}
              >
                {isCustom
                  ? "Custom WhatsApp messages"
                  : waMaxMessagesPerMonth > 0
                  ? `${Utils.numberWithCommas(waMaxMessagesPerMonth)} WhatsApp messages`
                  : "No WhatsApp messages"}
              </div>
              {tooltipVisible === `Plan ${idx + 1}` &&
                hoveredItem === "waMonthlyMessages" && (
                  <CustomTooltip
                    text={getTooltipContentForOutreach(
                      displayName,
                      "waMonthlyMessages",
                      waMaxMessagesPerMonth
                    )}
                    className="tooltipWaMonthlyMessages"
                  />
                )}
            </div>
          )}
          <div
            className="featureWrapper"
            onMouseEnter={() => {
              if (selectedTab.toLowerCase() === "outreach") {
                setTooltipVisible(`Plan ${idx + 1}`);
                setHoveredItem("deepResearch");
              }
            }}
            onMouseLeave={() => {
              if (selectedTab.toLowerCase() === "outreach") {
                setTooltipVisible(null);
                setHoveredItem(null);
              }
            }}
            style={{ position: "relative" }}
          >
            <div className="featureCheckIcon">
              {deepResearchEnabled > 0 ? <Check /> : <Cross />}
            </div>
            <div
              className="deepResearch"
              style={{
                ...(selectedTab?.toLowerCase() !== "data" && {
                  cursor: "pointer",
                  textDecoration: "underline dotted",
                  textUnderlineOffset: "5px"
                })
              }}
            >
              <div>Deep Research</div>
            </div>
            {tooltipVisible === `Plan ${idx + 1}` &&
              hoveredItem === "deepResearch" &&
              selectedTab.toLowerCase() === "outreach" && (
                <CustomTooltip
                  text={getTooltipContentForOutreach(
                    displayName,
                    "deepResearch",
                    deepResearchCreditsEligible
                  )}
                  className="tooltipDeepResearch"
                />
              )}
          </div>
          <div
            className="featureWrapper"
            onMouseEnter={() => {
              setTooltipVisible(`Plan ${idx + 1}`);
              setHoveredItem("filters");
            }}
            onMouseLeave={() => {
              setTooltipVisible(null);
              setHoveredItem(null);
            }}
            style={{ position: "relative" }}
          >
            <div className="featureCheckIcon">
              <Check />
            </div>
            <div
              className="filters"
              style={{
                cursor: "pointer",
                textDecoration: "underline dotted",
                textUnderlineOffset: "5px"
              }}
            >
              {isAdvancedFilters ? "Advanced Filters" : "Basic Filters"}
            </div>
            {tooltipVisible === `Plan ${idx + 1}` &&
              hoveredItem === "filters" && (
                <CustomTooltip
                  text={getTooltipContentForOutreach(
                    displayName,
                    "filters",
                    null
                  )}
                  className="tooltipFilters"
                />
              )}
          </div>
        </div>
      </>
    );
  };

  const toggleBtn = {
    leftText: "Monthly",
    checked: isChecked,
    rightText: "Annual",
    offerText: `Save 20%`,
    showOffer: true,
    action: getTogglePlanType
  };

  const handleDataTab = () => {
    setSelectedTab("Data");
    Utils.mixpanelTrack(MP_EVENT.PRICING_DATA_TAB, {
      pageType: Utils.getPageType() || ""
    });
  };
  const handleOutreachTab = () => {
    setSelectedTab("Outreach");
    Utils.mixpanelTrack(MP_EVENT.PRICING_OUTREACH_TAB, {
      pageType: Utils.getPageType() || ""
    });
  };

  useEffect(() => {
    PricingStore.getActivePlanDetails();
    PricingStore.getDataOutreachPlans();
  }, []);

  return (
    <div className="planCardSectionWrapper">
      <div className="tabSelector">
        <div className="tabItemWrapper">
          <div
            className={`dataPlan tabItem ${
              selectedTab === "Data" ? "activeTab" : ""
            }`}
            onClick={() => handleDataTab()}
          >
            <DataPlanIcon className="dataPlanIcon" /> Data
          </div>

          <div
            className={`outreach tabItem ${
              selectedTab === "Outreach" ? "activeTab" : ""
            }`}
            onClick={() => handleOutreachTab()}
          >
            <OutreachPlanIcon className="outreachPlanIcon" /> Outreach
          </div>
        </div>
        <div className="side-line"></div>
      </div>
      <div className={`sectionContainer container-fluid`}>
        <p className={`desc mb-3 mb-md-4`}>
          {selectedTab === "Outreach" ? (
            <>
              Run multi-channel outreach across email, LinkedIn, and phone.{" "}
              <br />
              Use credits to unlock verified contact data and power your
              workflows.
            </>
          ) : (
            <>
              Get more emails, phone numbers, and research insights with
              flexible monthly credits.
              <br /> Use them however you like — email, phone, or deep research.
            </>
          )}
        </p>
      </div>
      <div className="planCardSection">
        <div className="planCardSectionPricingToogle">
          <div className="centerToggle">
            <div className="flexBtnParentWrapper">
              {selectedTab === "Outreach" ? (
                <>
                  <div className="flexBtnWrapper startFreeToday">
                    <a
                      href="#comparePlans"
                      className={`comparePlan startFreeToday align-items-center justify-content-center`}
                      rel="noreferrer noopener"
                    >
                      Start Free Today
                    </a>
                  </div>
                  <div className="flexBtnWrapper">
                    <a
                      href="#comparePlans"
                      className={`comparePlan compareFeatures align-items-center justify-content-center`}
                      rel="noreferrer noopener"
                    >
                      Compare Plans
                    </a>
                  </div>
                </>
              ) : (
                <>
                  {" "}
                  <div className="flexBtnWrapper">
                    <a
                      href="#comparePlans"
                      className={`comparePlan startFreeTrial align-items-center justify-content-center`}
                      rel="noreferrer noopener"
                    >
                      Start Free Today
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="rightToggle">
            <ToggleSwitch {...toggleBtn} />
          </div>
        </div>

        <div className="container">
          <div className="planCardWrapper">
            {(
              (selectedTab === "Data"
                ? dataOutreachPlans?.dataPlans
                : dataOutreachPlans?.outreachPlans) || []
            ).map((item, idx) => {
              const {
                displayName = "",
                price = "",
                annualPrice = "",
                name = ""
              } = item || {};
              const displayValue = pricingPlanObj?.[name?.toLowerCase()];
              return (
                <div className="planCardItem">
                  {displayValue?.isPopular && (
                    <div className="mostPopularBadge">
                      <MostPopular />
                    </div>
                  )}
                  <div
                    className={`planCard ${
                      displayValue?.isPopular ? "isPopularPlanCard" : ""
                    }`}
                  >
                    <div
                      className="planName"
                      style={{ color: displayValue?.color }}
                    >
                      {displayName?.toLowerCase() === "custom"
                        ? "Enterprise"
                        : displayName}
                    </div>
                    {displayName?.toLowerCase() === "custom" ? (
                      <div className="planAmount">Custom</div>
                    ) : (
                      <div className="planAmount">
                        <div className={`planString  ${displayName}`}>
                          <sup className="planDollar">$</sup>
                          <span className="planAmount">
                            {PricingStore.paymentFormInfo.annual
                              ? annualPrice
                              : price}
                          </span>
                          {displayValue?.planAmountSubText && (
                            <div className="flexColumn">
                              <p
                                className={`planAmountSubText ${displayName}`}
                              >{`${displayValue?.planAmountSubText}`}</p>
                              <p className="planAmountMonthlyText">
                                {displayValue?.billedMonthly && (
                                  <p>{`(Billed Monthly)`}</p>
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {showCurrentPlanDom(item) ? (
                      <div
                        className="currentPlanBtn"
                        onClick={() => history.push("/settings/billing")}
                      >
                        Current Plan
                      </div>
                    ) : (
                      getActionButton(item)
                    )}

                    {getCreditsData(
                      item,
                      idx,
                      dataOutreachPlans?.outreachPlans
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
});

export { PricingPlans };
export default PricingPlans;
